// extracted by mini-css-extract-plugin
export default {"about_partner":"Partner_about_partner__56Rb3"};